export default "__VITE_ASSET__CkKzoj_4__"